import './authentication.styles.scss';
import SignInForm from '../../components/sign-in-form/sign-in-form.component';

const Authentication = () => {
    return (
        <div className='authentication-container'>
            <SignInForm/>
        </div>
    )
}

export default Authentication;